import { useRef, useEffect } from 'react';

export const usePrevRecord = ({
  calibratedLevelDbSPL,
  setCalibratedLevelDbSPL,
  deltaDuration,
}) => {
  const animationFrameRef = useRef(null);
  const animationStartRef = useRef(null);
  const animationDurationRef = useRef(deltaDuration);
  const startValueRef = useRef(0);
  const changeLevelRef = useRef(0);

  useEffect(() => {
    animationDurationRef.current = deltaDuration;
  }, [deltaDuration]);

  const setNoizeLevel = (needValue) => {
    const startValue = Number(calibratedLevelDbSPL);
    const changeLevel = needValue - startValue;

    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
      animationStartRef.current = null;
    }

    if (Math.abs(changeLevel) < 0.01) {
      setCalibratedLevelDbSPL(needValue.toFixed(1));
      return;
    }

    startValueRef.current = startValue;
    changeLevelRef.current = changeLevel;

    const animate = (timestamp) => {
      if (!animationStartRef.current) {
        animationStartRef.current = timestamp;
      }

      const elapsed = timestamp - animationStartRef.current;
      const progress = Math.min(elapsed / animationDurationRef.current, 1);

      const currentValue =
        startValueRef.current + changeLevelRef.current * progress;
      setCalibratedLevelDbSPL(currentValue.toFixed(1));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setCalibratedLevelDbSPL(needValue.toFixed(1));
        animationFrameRef.current = null;
        animationStartRef.current = null;
      }
    };

    animationFrameRef.current = requestAnimationFrame(animate);
  };

  return { setNoizeLevel };
};
